export default "__VITE_ASSET__NtEU_5Pm__$_?url__"